module.exports = __webpack_public_path__ + "img/step_2.00fc0110.png";